
import './App.css';
import TopNavBar from '../src/components/TopNavBar.js';
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Home from './pages/Home';
import Donation from './pages/Donate';

function App() {


  return (
    <BrowserRouter>

      <div id="app">

        <div id="pageContent">

          <Routes>

            <Route exact path="/" element={<Home />} />
            <Route exact path="/Donate" element={<Donation />} />
          </Routes>

        </div>

      </div>

    </BrowserRouter>
  );
}

export default App;
